import React from "react";
import styles from "./styles.module.css";
import { useDispatch } from "react-redux";
import {
  deleteCourse,
  deleteLessonPlan,
  deleteHomework,
} from "../../../../store/actions/course";
import { toast } from "react-toastify";

const DeleteConfirmationModal = (props) => {
  const { selectedCourse, activeTab, setApiCalled, handleModal } = props;
  const dispatch = useDispatch();

  const getSingular = (name) => {
    if (name === "Homework") return "Homework";
    return name.slice(0, -1);
  };

  const handleDelete = async () => {
    setApiCalled(false);
    const payload = {
      id: selectedCourse._id || selectedCourse.id,
    };

    // show Loader
    const loader = document.getElementById("loader");
    if (loader) loader.style.display = "flex";

    try {
      let result;
      if (activeTab === "Courses") {
        result = await dispatch(deleteCourse(payload));
      } else if (activeTab === "Lesson Plans") {
        result = await dispatch(deleteLessonPlan(payload));
      } else if (activeTab === "Homework") {
        result = await dispatch(deleteHomework(payload));
      }

      // hide Loader
      if (loader) loader.style.display = "none";

      const successMsg = result?.msg || result?.message || (typeof result === "string" ? result : "");
      if (result?.status === 1 || successMsg.includes("Successfully") || result === "Deleted Successfully") {
        toast.success(`${getSingular(activeTab)} Deleted Successfully`);
        setApiCalled((prev) => !prev);
        handleModal(false);
      } else {
        toast.error(result?.message || result?.msg || "Failed to Delete");
      }
    } catch (err) {
      console.error(err);
      if (loader) loader.style.display = "none";
      toast.error("An error occurred");
    }
  };

  return (
    <div className={styles.modalBackdrop}>
      <div className={styles.modal}>
        <h3>Are you sure you want to delete this {getSingular(activeTab)}?</h3>

        <div className={styles.actions}>
          <button onClick={() => handleModal(false)}>Cancel</button>
          <button onClick={handleDelete} className={styles.deleteButton}>Delete</button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
